import { createFileRoute } from '@tanstack/react-router';
import { DesktopWarehouses } from '@/features/warehouse/DesktopWarehouses';

/** Anagrafica delle sedi di stoccaggio. Prima delle ubicazioni: una senza l'altra non esiste. */
export const Route = createFileRoute('/_app/warehouse/warehouses')({ component: DesktopWarehouses });
